/* VALKA — cinta de anuncios: velocidad constante, pausa accesible y movimiento reducido. */
(function () {
  if (customElements.get('valka-ticker')) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class ValkaTicker extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.valka-ticker__track');
      this.group = this.querySelector('.valka-ticker__group');
      this.toggle = this.querySelector('.valka-ticker__toggle');
      if (!this.track || !this.group) return;

      this.onResize = this.updateDuration.bind(this);
      this.onMotionChange = this.updateMotion.bind(this);

      if (this.toggle) {
        this.toggle.addEventListener('click', () => this.setPaused(!this.classList.contains('is-paused')));
      }

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.group);
      } else {
        window.addEventListener('resize', this.onResize);
      }

      if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', this.onMotionChange);
      this.updateMotion();
      this.updateDuration();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      window.removeEventListener('resize', this.onResize);
      if (reducedMotion.removeEventListener) reducedMotion.removeEventListener('change', this.onMotionChange);
    }

    updateMotion() {
      if (this.toggle) this.toggle.hidden = reducedMotion.matches;
    }

    /* Duración según el ancho real, para que la velocidad (px/s) sea igual en móvil y computador. */
    updateDuration() {
      const pxPerSecond = parseFloat(this.dataset.speed) || 120;
      const width = this.group.getBoundingClientRect().width;
      if (width > 0) this.style.setProperty('--ticker-duration', `${(width / pxPerSecond).toFixed(2)}s`);
    }

    setPaused(paused) {
      this.classList.toggle('is-paused', paused);
      if (!this.toggle) return;
      this.toggle.setAttribute('aria-pressed', String(paused));
      this.toggle.setAttribute('aria-label', paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause);
    }
  }

  customElements.define('valka-ticker', ValkaTicker);
})();
